export default {
  location: [2],
  fixed: true,
  textColor: "#000000",
  fontSize: 10,
  hoverTextColor: '#ae9a69'
};